import { runGame } from "@shared/actions/games";
import { useGameSession } from "@shared/hooks/games";
import { useQueryAllData } from "@shared/modules/core/query/use-query-app";
import { poller } from "@shared/services";
import { RunType } from "@shared/types";
import { getGameRunType } from "@shared/utils/run-type";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

const DEFAULT_POLLING_LOBBY_DATA_INTERVAL = 10_000;

export function usePollLobbyDataService() {
  const dispatch = useDispatch();
  const { fetchAllData } = useQueryAllData();
  const history = useHistory();
  const { stringId } = useParams<{ stringId: string }>() ?? {};

  const isGamePage = history?.location?.pathname.includes("/games/");
  const gameSession = useGameSession();

  const fetchAndCheckUserGame = useCallback(async () => {
    if (gameSession === null) {
      await fetchAllData();
    }

    if (gameSession === null && isGamePage && stringId) {
      dispatch(
        runGame({
          game: stringId,
          demo: false,
          place: getGameRunType(RunType.game_list),
        })
      );
    }
  }, []);

  useEffect(() => {
    const { disposeCallback } = poller.poll(
      fetchAndCheckUserGame,
      DEFAULT_POLLING_LOBBY_DATA_INTERVAL
    );
    return () => disposeCallback();
  }, [gameSession]);
}
